const styles = {
  avatar: {
    height: "25px",
    width: "25px",
  },
};

export default styles;
